// Hazır spor kitabı (Flexrix / Betby) kuponlarının panel tarafındaki ortak
// parçaları. İki ekran kullanır — Spor Bahisleri sayfasının **Hazır Spor
// Kitabı** sekmesi ve üye profilindeki Bahis Geçmişi'nin aynı adlı sekmesi;
// ayrışırlarsa aynı kupon iki ekranda iki farklı şey söylerdi (sitenin kendi
// kuponlarında `lib/sportsBets.js` aynı işi yapar).

export const HOSTED_STATUS_BADGES = {
  pending: { label: 'Sonuç bekleniyor', cls: 'badge-yellow' },
  won: { label: 'Kazandı', cls: 'badge-green' },
  half_won: { label: 'Yarı kazandı', cls: 'badge-green' },
  lost: { label: 'Kaybetti', cls: 'badge-red' },
  half_lost: { label: 'Yarı kaybetti', cls: 'badge-red' },
  void: { label: 'İade', cls: 'badge-gray' },
  cashed_out: { label: 'Cashout', cls: 'badge-yellow' },
};

export const hostedBadge = (status) => (
  HOSTED_STATUS_BADGES[status] || HOSTED_STATUS_BADGES.pending
);

// "Sonuç bekleniyor" kaybetti demek değildir; kaybeden kuponda sağlayıcı
// kazanç çağrısı yapmaz ve spor kuponu günlerce açık kalır.
export const PENDING_HINT = 'Sağlayıcı kuponun sonucunu henüz bildirmedi. '
  + 'Spor kuponu günlerce açık kalabilir; kaybeden kuponda sağlayıcı kazanç '
  + 'çağrısı yapmadığı için sonuç ancak kupon bildirimiyle kesinleşir.';

export const PICK_RESULT_CLASS = {
  won: 'text-emerald-400',
  half_won: 'text-emerald-400',
  lost: 'text-rose-400',
  half_lost: 'text-rose-400',
  void: 'text-slate-500',
};

// Bacağın "market: seçim" satırı. Sağlayıcıların alan adları sözleşmede
// sabit olmadığı için ikisi de boş olabilir; o zaman elde ne varsa yazılır —
// uydurma bir etiket, eksik bir etiketten kötüdür.
export const legLabel = (leg) => {
  const market = (leg.market || '').trim();
  const pick = (leg.pick || '').trim();
  if (market && pick) return `${market}: ${pick}`;
  return pick || market || '';
};

// Kuponun içeriği yerelde yoksa sağlayıcıya sorulur. Uç kupon başınadır ve
// sonucu saklar: aynı kupon ikinci kez sorulmaz.
export const hostedDetailPath = (item) => (
  `/admin/sportsbook-bets/${item.provider}/${encodeURIComponent(item.bet_id)}`
);

// Toplu okuma yolu. Sağlayıcı destekliyorsa (bugün yalnızca Flexrix) bir
// sayfanın bütün eksik kuponları **tek** istekte gelir; kupon başına istek
// atmak sayfayı sağlayıcı için bir taramaya çevirir ve kenar katmanının
// kotasına takılır. Sunucu destek yoksa yalnızca yereldekileri döndürür,
// çağıran taraf kalanı tek tek ister.
export const BULK_DETAIL_PROVIDERS = new Set(['flexrix']);
export const BULK_DETAIL_MAX = 50;

export const hostedDetailsPath = (provider, betIds) => (
  `/admin/sportsbook-bets/${provider}/details`
  + `?ids=${encodeURIComponent(betIds.join(','))}`
);
